module.exports = "/images/PR.png?2e205e9c392e3cfb8fbb4ca9108d0572";